module.exports = __webpack_public_path__ + "static/media/realestate1.1f32e1b5.png";